
const setup = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/setup.vue')
const password = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/password.vue')
const BindingAccount = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/BindingAccount.vue')
const feedback = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/feedback.vue')
const idea = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/idea.vue')
const ideaDesc = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/ideaDesc.vue')
const account = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/account.vue')
const about = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/about.vue')
const money_password = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/money_password.vue')
const money_password_exid = () => import(/* webpackChunkName: "me-setup" */ '@/views/me/setup/money_password_exid.vue')

const topup = () => import(/* webpackChunkName: "me-purse" */ '@/views/me/purse/topup.vue')
const exchange = () => import(/* webpackChunkName: "me-purse" */ '@/views/me/purse/exchange.vue')
const withdraw = () => import(/* webpackChunkName: "me-purse" */ '@/views/me/purse/withdraw.vue')

const collect = () => import(/* webpackChunkName: "me-collect" */ '@/views/me/collect/collect.vue')
const collectSearch = () => import(/* webpackChunkName: "me-collect" */ '@/views/me/collect/search.vue')
const comment = () => import(/* webpackChunkName: "me-social" */ '@/views/me/comment.vue')
const follow = () => import(/* webpackChunkName: "me-social" */ '@/views/me/follow.vue')
const fans = () => import(/* webpackChunkName: "me-social" */ '@/views/me/fans.vue')
const Blacklist = () => import(/* webpackChunkName: "me-social" */ '@/views/me/Blacklist.vue')
const upvote = () => import(/* webpackChunkName: "me-social" */ '@/views/me/upvote.vue')

const room = () => import(/* webpackChunkName: "me-room" */ '@/views/me/room/room.vue')
const roomSearch = () => import(/* webpackChunkName: "me-room" */ '@/views/me/room/search.vue')

const report = () => import(/* webpackChunkName: "me-report" */ '@/views/me/report/report.vue')
const reportdesc = () => import(/* webpackChunkName: "me-report" */ '@/views/me/report/reportDesc.vue')
const rankingFans = () => import(/* webpackChunkName: "me-ranking" */ '@/views/me/ranking/fans.vue')
const rankingShare = () => import(/* webpackChunkName: "me-ranking" */ '@/views/me/ranking/share.vue')
const rankingGrade = () => import(/* webpackChunkName: "me-ranking" */ '@/views/me/ranking/grade.vue')
const rankingGift = () => import(/* webpackChunkName: "me-ranking" */ '@/views/me/ranking/gift.vue')
const activity = () => import(/* webpackChunkName: "me-activity" */ '@/views/me/activity.vue')
const Invite = () => import(/* webpackChunkName: "me-invite" */ '@/views/me/Invite.vue')
const grade = () => import(/* webpackChunkName: "me-grade" */ '@/views/me/grade/grade.vue')
const integral = () => import(/* webpackChunkName: "me-grade" */ '@/views/me/grade/integral.vue')
const kf = () => import(/* webpackChunkName: "me-kf" */ '@/views/me/kf.vue')
const addinvite = () => import(/* webpackChunkName: "me-invite" */ '@/views/me/addinvite.vue')

const meRoute = [
 
    {
        path: '/me/setup',
        name: 'setup',
        component: setup,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/setup/password',
        name: 'setupPassword',
        component: password,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/setup/BindingAccount',
        name: 'BindingAccount',
        component: BindingAccount,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/setup/feedback',
        name: 'feedback',
        component: feedback,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/setup/feedback/idea',
        name: 'idea',
        component: idea
    },
    {
        path: '/me/setup/feedback/details',
        name: 'ideaDesc',
        component: ideaDesc,
        meta:{
            needLogin: true
        }
    },
    
    
    {
        path: '/me/setup/account',
        name: 'account',
        component: account,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/setup/about',
        name: 'about',
        component: about,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/purse/topup',
        name: 'topup',
        component: topup,
        meta:{
            needLogin: true
        }
    },  
     {
        path: '/me/purse/exchange',
        name: 'exchange',
        component: exchange,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/purse/withdraw',
        name: 'withdraw',
        component: withdraw,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/collect',
        name: 'collect',
        component: collect,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/collect/search',
        name: 'collectSearch',
        component: collectSearch,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/comment',
        name: 'mEcomment',
        component: comment,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/follow',
        name: 'follow',
        component: follow,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/fans',
        name: 'meFans',
        component: fans,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/blacklist',
        name: 'Blacklist',
        component: Blacklist,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/upvote',
        name: 'upvote',
        component: upvote,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/me/room',
        name: 'room',
        component: room,
        meta:{
            needLogin: true
        }
    }, 
    {
        path: '/me/room/search',
        name: 'roomSearch',
        component: roomSearch,
        meta:{
            needLogin: true
        }
    }, 
      
     {
        path: '/me/report',
        name: 'report',
        component: report,
        meta: {
            keepAlive: true,
            needLogin: true
        },
    },   
    {
       path: '/me/report/details',
       name: 'reportdesc',
       component: reportdesc,
       meta:{
        needLogin: true
    }
   },


   {
    path: '/me/ranking/fans',
    name: 'rankingFans',
    component: rankingFans,

    }
    ,
   {
    path: '/me/ranking/share',
    name: 'rankingShare',
    component: rankingShare,
  
    } ,
    {
    path: '/me/ranking/grade',
    name: 'rankingGrade',
    component: rankingGrade,
  
    }
    ,
    {
    path: '/me/ranking/gift',
    name: 'rankingGift',
    component: rankingGift,

    }
    ,
    {
    path: '/me/ranking/gift',
    name: 'rankingGift',
    component: rankingGift,

    }
    ,
    {
        path: '/me/activity',
        name: 'activity',
        component: activity,
    }
    ,
    {   
        path: '/me/invite',
        name: 'Invite',
        component: Invite,
        meta:{
            needLogin: true
        }
    }
    ,
    {   
        path: '/me/grade',
        name: 'grade',
        component: grade,
    }
    ,
    {   
        path: '/me/grade/integral',
        name: 'integral',
        component: integral,
        meta:{
            needLogin: true
        }
    }
    ,
    {   
        path: '/me/kf',
        name: 'kf',
        component: kf
    }
    ,
    {   
        path: '/me/addinvite',
        name: 'addinvite',
        component: addinvite
    }
    ,
    {   
        path: '/me/setup/money/password',
        name: 'money_password',
        component: money_password
    }
    ,
    {   
        path: '/me/setup/money/password/exit',
        name: 'money_password_exid',
        component: money_password_exid
    }

    
    
       
       
    
]

export default meRoute
